import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../ui/dialog';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../../ui/alert-dialog';
import { ColorImage } from '../ColorImage';

export const ImagePreviewDialog = ({ open, onOpenChange, image }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl" data-testid="image-preview-dialog">
      <DialogHeader>
        <DialogTitle>{image?.name}</DialogTitle>
      </DialogHeader>
      <div className="flex justify-center p-4">
        {image?.image_url && (
          <ColorImage src={image.image_url} alt={image.name} w={1024} eager fit="contain" className="w-full h-[60vh] rounded-lg overflow-hidden" />
        )}
      </div>
    </DialogContent>
  </Dialog>
);

const CASCADE_NOTE = {
  brand: ' All collections under this brand will also be deleted.',
  collection: ' All materials and colors in this collection will also be deleted.',
  material: ' All colors for this material will also be deleted.',
};

export const DeleteConfirmDialog = ({ open, onOpenChange, target, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="delete-confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Delete {target?.type}?</AlertDialogTitle>
        <AlertDialogDescription>
          Are you sure you want to delete "{target?.name}"? This action cannot be undone.
          {CASCADE_NOTE[target?.type] || ''}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-red-600 hover:bg-red-700" data-testid="delete-confirm-btn">Delete</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
